import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };

export default function AdminReviewsPage() {
  const [pending, setPending] = useState([]);
  const [history, setHistory] = useState([]);
  const [stats, setStats] = useState({});
  const [tab, setTab] = useState('pending');
  const [note, setNote] = useState({});
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const [p, h, s] = await Promise.all([
        axios.get('/api/admin/reviews'),
        axios.get('/api/admin/reviews/history'),
        axios.get('/api/admin/reviews/stats'),
      ]);
      setPending(p.data);
      setHistory(h.data);
      setStats(s.data);
    } catch (err) {
      if (err.response?.status === 403) setMsg('仅管理员可访问');
      else setMsg('加载失败');
    }
  };

  const review = async (shopId, action) => {
    try {
      const r = await axios.post(`/api/admin/reviews/${shopId}`, { action, note: note[shopId] || '' });
      setMsg(r.data.message);
      load();
      setTimeout(() => setMsg(''), 2000);
    } catch { setMsg('操作失败'); }
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>🔍 店铺审核管理</h2>
        <p className="subtitle">人工审核开店申请</p>
      </div>

      {msg && <div className="alert" style={msg.includes('✅')?{background:'rgba(74,222,128,0.15)',color:'#4ade80',textAlign:'center',border:'1px solid rgba(74,222,128,0.2)'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b',textAlign:'center'}}>{msg}</div>}

      {/* 统计 */}
      <div className="discovery-stats">
        <div className="stat-item"><div className="stat-number">{stats.pending||0}</div><div className="stat-label">待审核</div></div>
        <div className="stat-item"><div className="stat-number">{stats.approved||0}</div><div className="stat-label">已通过</div></div>
        <div className="stat-item"><div className="stat-number">{stats.rejected||0}</div><div className="stat-label">已拒绝</div></div>
      </div>

      <div className="discovery-filters">
        <button className={`filter-btn ${tab==='pending'?'active':''}`} onClick={()=>setTab('pending')}>⏳ 待审核 ({pending.length})</button>
        <button className={`filter-btn ${tab==='history'?'active':''}`} onClick={()=>setTab('history')}>📜 审核历史</button>
      </div>

      {tab === 'pending' && (
        pending.length === 0 ? (
          <div style={{textAlign:'center',padding:60,color:'var(--text-dim)'}}>
            <div style={{fontSize:'3rem',marginBottom:12}}>✅</div>
            <p>没有待审核的店铺</p>
          </div>
        ) : (
          <div className="users-grid">
            {pending.map(s => (
              <div key={s.id} className="product-card">
                <div className="product-info">
                  <div className="product-title">{s.logo||'🏪'} {s.name}</div>
                  <div className="product-desc">{s.description}</div>
                  <div className="product-meta" style={{margin:'8px 0'}}>
                    <span className="meta-badge">{FLAGS[s.country_code]||'🌍'} {s.country_code}</span>
                    <span className="meta-badge">👤 {s.ownerName}</span>
                  </div>
                  <div style={{margin:'8px 0',padding:8,background:'rgba(255,255,255,0.04)',borderRadius:8,fontSize:'0.82rem'}}>
                    <div>👤 法人: {s.legalPerson?.name}</div>
                    <div>🪪 证件: {s.legalPerson?.idType} · {s.legalPerson?.idNumber}</div>
                    {s.legalPerson?.phone && <div>📞 {s.legalPerson.phone}</div>}
                    <div>📧 {s.ownerEmail}</div>
                    <div>🌐 语言: {(s.languages||[]).join(', ')}</div>
                  </div>
                  <div className="field">
                    <textarea value={note[s.id]||''} onChange={e=>setNote(n=>({...n,[s.id]:e.target.value}))}
                      rows={2} placeholder="审核备注（可选）" style={{fontSize:'0.8rem'}} />
                  </div>
                  <div style={{display:'flex',gap:8}}>
                    <button className="btn btn-primary" style={{flex:1,background:'linear-gradient(135deg,#4ade80,#22c55e)'}}
                      onClick={() => review(s.id, 'approve')}>✅ 通过</button>
                    <button className="btn btn-secondary" style={{flex:1,background:'rgba(239,68,68,0.15)',color:'#ef4444',border:'1px solid rgba(239,68,68,0.2)'}}
                      onClick={() => review(s.id, 'reject')}>❌ 拒绝</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}

      {tab === 'history' && (
        <div className="users-grid">
          {history.map(s => (
            <div key={s.id} className="product-card" style={{opacity:0.8}}>
              <div className="product-title">{s.logo} {s.name}</div>
              <div className="product-meta">
                <span className="meta-badge" style={s.reviewStatus==='approved'?{background:'rgba(74,222,128,0.15)',color:'#4ade80'}:{background:'rgba(239,68,68,0.15)',color:'#ef4444'}}>
                  {s.reviewStatus === 'approved' ? '✅ 通过' : '❌ 拒绝'}
                </span>
                <span className="meta-badge">👤 {s.ownerName}</span>
              </div>
              {s.reviewNote && <div className="product-desc">备注: {s.reviewNote}</div>}
              <div className="product-seller">审核人: {s.reviewer} · {s.reviewedAt ? new Date(s.reviewedAt).toLocaleString('zh-CN') : ''}</div>
            </div>
          ))}
          {history.length === 0 && <div style={{gridColumn:'1/-1',textAlign:'center',padding:40,color:'var(--text-dim)'}}>暂无记录</div>}
        </div>
      )}
    </div>
  );
}
